export default __webpack_public_path__ + "static/media/r6e-logo.80372d36.png";